module.exports = __webpack_public_path__ + "static-portal/img/3.635af12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.jpg
// module id = ihpy
// module chunks = 4